'use client';

import { useEffect } from 'react';
import type { Country } from '@/helpers/conf';
import { ANJOUAN_COUNTRIES } from '@/modules/policies/constants';
import { useGetCommonStore } from '@/store';

declare global {
  interface Window {
    anj_72c87df8_3bc2_415b_bb6a_2e8f3214d471?: {
      init: () => void;
    };
  }
}

export const FooterAnjouanSeal = () => {
  const useCommonStore = useGetCommonStore();
  const countryCode = useCommonStore.use.countryCode();

  // Check if the current country requires Anjouan licensing
  const isAnjouanCountry = ANJOUAN_COUNTRIES.includes(countryCode as Country);

  useEffect(() => {
    // Initialize the Anjouan seal after component mounts
    if (
      isAnjouanCountry &&
      typeof window !== 'undefined' &&
      window.anj_72c87df8_3bc2_415b_bb6a_2e8f3214d471
    ) {
      window.anj_72c87df8_3bc2_415b_bb6a_2e8f3214d471.init();
    }
  }, [isAnjouanCountry]);

  // Only render for Anjouan countries
  if (!isAnjouanCountry) {
    return null;
  }

  return (
    <div
      data-anj-image-size="128"
      data-anj-image-type="basic-small"
      data-anj-seal-id="72c87df8-3bc2-415b-bb6a-2e8f3214d471"
      id="anj-72c87df8-3bc2-415b-bb6a-2e8f3214d471"
    />
  );
};
